module.exports = __webpack_public_path__ + "static/media/kcsa_logo.b0a33a24.png";